import { render, staticRenderFns } from "./modalnputDetail.vue?vue&type=template&id=bf6a2d60&scoped=true"
import script from "./modalnputDetail.vue?vue&type=script&lang=js"
export * from "./modalnputDetail.vue?vue&type=script&lang=js"
import style1 from "./modalnputDetail.vue?vue&type=style&index=1&id=bf6a2d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6a2d60",
  null
  
)

export default component.exports